// extracted by mini-css-extract-plugin
export default {"form":"styles_form__T2RxY","input":"styles_input__xSgs2"};